// react components
import React from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import TextareaAutosize from 'react-textarea-autosize'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type TextAreaInput816SiteProps = {
    directionRtl?: boolean
    disabled?: boolean
    error: string | undefined
    label: string
    name: string
    onChange: any
    placeholder?: string
    value: string
}

// main
export const TextAreaInput816Site: React.FC<TextAreaInput816SiteProps> = React.memo(({
    directionRtl,
    disabled,
    error,
    label,
    name,
    onChange,
    placeholder,
    value,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    function onInputChange(value: string | null | undefined) {
        try {
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextAreaInput816Site',
                'onInputChange',
            ))
        }
    }

    return (
        <div className={`input-816 text-area-input-816 ${deviceType}`}>
            <span className={`input-816-label ${deviceType}`}>{label}</span>
            <TextareaAutosize
                className={`tai-816-input${directionRtl ? ' rtl' : ''} ${deviceType}`}
                disabled={disabled}
                name={name}
                onChange={(e) => onInputChange(e.target.value)}
                placeholder={placeholder}
                rows={1}
                value={value}
            />
            {error && <span className='input-816-error'>{error}</span>}
        </div>
    )
})
